import { createRoute } from '@tanstack/react-router';
import { ParametresPage } from '@/features/settings/parametres-page.js';
import { parseParametresSearch } from '@/features/settings/search-params.js';
import { authenticatedRoute } from './authenticated.js';

/**
 * `/parametres` — écran Paramètres (`02` §12), 6 onglets. Pas de sélecteur de
 * boutique global (`staticData.showStoreSelector`) : le scope boutique de cet
 * écran est l'onglet Boutiques lui-même, piloté par son propre paramètre
 * `store` (fiche boutique / création), jamais le sélecteur de la `TopBar`.
 *
 * `component` vit dans `features/settings/parametres-page.tsx`, pas ici : il
 * lit `tab`/`store` via `useSearch({strict:false})` (générique, voir
 * `readParametresSearch`) plutôt que `parametresRoute.useSearch()`, pour
 * éviter un import circulaire route ↔ composant et rester testable avec
 * `renderWithRouter` (voir `README-shell.md`, section « Ajouter une route »,
 * et le rapport de cette vague).
 */
export const parametresRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/parametres',
  validateSearch: parseParametresSearch,
  component: ParametresPage,
});

/** Exporté en tableau pour la composition centrale (`src/router.tsx`, hors périmètre de cette vague). */
export const parametresRoutes = [parametresRoute];
